
export default{
    /**
     * 用户信息
     */
    userInfo: null,
    /**
     * 请求token
     */
    token: '',

    webSocketMsg: ''

}



// WEBPACK FOOTER //
// ./src/store/state.js